const otpModel = {
    id: "otp",
    fields: {
        phoneNum: "phoneNum",
        otp: "otp"
    }
};

export { otpModel };
//# sourceMappingURL=otpModel.js.map
